export default __webpack_public_path__ + "static/media/grenade-launcher-flat.e305972e.svg";